module.exports = __webpack_public_path__ + "media/images/aloe/icons/money-79738add30c2853a47688f3f5adf8d4d.svg";